// eslint-disable-next-line import/prefer-default-export
export const LINK = {
  GO_TO_CUPRUM: 'https://www.cuprum.cl/wwwcuprum/Login.aspx',
  CHANGE_TO_CUPRUM: 'https://www.cuprum.cl/OtiWebV2/#/Login',
  PASSWORD_RECOVERY: 'https://www.cuprum.cl/wwwcuprum/RecuperarClave.aspx',
};
